import createClient from 'openapi-fetch';
import { sanitizeUrlForTelemetry } from '@/services/errorParser';
import { createHttpFetch, type HttpCallOptions } from '@/services/http';
import type { paths } from './v1.gen';

export interface ApiClientConfig {
  baseUrl?: string;
  fetchImpl?: typeof fetch;
  headers?: () => Record<string, string>;
}

export type ApiClient = ReturnType<typeof createApiClient>;

export function createApiClient(config: ApiClientConfig = {}) {
  const send = createHttpFetch({
    fetchImpl: config.fetchImpl,
    headers: config.headers,
  });
  const client = createClient<paths>({
    baseUrl: `${(config.baseUrl ?? '').replace(/\/+$/, '')}/api`,
    fetch: (request) => send(request),
  });
  return {
    GET: client.GET,
    POST: client.POST,
    transport(options: HttpCallOptions) {
      return { fetch: (request: Request) => send(request, options) };
    },
  };
}

// The transport throws HttpError on every non-2xx, so only an empty 2xx body
// can leave `data` unset here.
export async function unwrap<T>(
  call: Promise<{ data?: T; response: Response }>
): Promise<T> {
  const { data, response } = await call;
  if (data === undefined) {
    throw new Error(
      `Empty response body from ${sanitizeUrlForTelemetry(response.url)}`
    );
  }
  return data;
}
